import { ChangeDetectionStrategy, Component, Input, OnInit } from "@angular/core";
import dayjs from "@gtmhub/dayjs";
import { IGoal } from "@gtmhub/goals/models";
import { Session } from "@webapp/sessions/models/sessions.model";

@Component({
  selector: "goal-bar-progress",
  templateUrl: "./goal-bar-progress.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GoalProgressBarComponent implements OnInit {
  @Input() public goal: IGoal;
  @Input() public planningSession: Session;
  @Input() public coloringStrategy: string;

  public formattedSoftDueDate: string;

  public ngOnInit(): void {
    this.formattedSoftDueDate = dayjs(this.goal.dateTo).format("DD MMMM, YYYY");
  }
}
